import { useEffect } from 'react'

/**
 * A page that knows its own title and has no entry in `STATIC_META`: the portal
 * pages and the 404. The route meta falls back to the home page's title for those,
 * which put "Archis — upgrade your AI coding agent" on every portal tab and on their
 * PostHog pageviews (#935).
 *
 * Page effects run before the pageview tracker's lazy meta lookup resolves, so the
 * tracker asks `titleClaimedFor` before writing the fallback over it.
 */
let claimedPath: string | null = null

export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = `${title} — Archis`
    claimedPath = window.location.pathname
  }, [title])
}

export function titleClaimedFor(pathname: string): boolean {
  return claimedPath === pathname
}
